"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMilestone = getMilestone;
exports.getAward = getAward;
const milestones_json_1 = __importDefault(require("@/genfiles/milestones.json"));
const awards_json_1 = __importDefault(require("@/genfiles/awards.json"));
const milestones = {};
const awards = {};
milestones_json_1.default.forEach((e) => {
    milestones[e.name] = e;
});
awards_json_1.default.forEach((e) => {
    awards[e.name] = e;
});
function getMilestone(name) {
    return milestones[name];
}
function getAward(name) {
    return awards[name];
}
